module.exports = __webpack_public_path__ + "static/media/cell-phone.a1997789.jpg";